import React from "react";
import Fa from 'react-fontawesome'
import moment from 'moment'

export default class DeviceInfoBar extends React.Component {


  render() {
    let device = this.props.data
    let fmt = 'YYYY-MM-DD HH:mm:ss'
    let color = device.state === 'OFFLINE' ? 'orange' : 'green'
    let bcolor = device.battery_voltage  < device.low_battery_threshold_on ? 'orange' : 'green'
    let network

    if (device.rssi > 80) {network = 'very low'}
    else if (device.rssi > 75) {network = 'low'}
    else if (device.rssi > 55) {network = 'medium'}
    else {network = 'high'}

    return (
      <div className='infobar'>
        <div>
            <p className="lbl">ID</p>
            <p>{device.device_id}
            </p>
        </div>
        <div>
            <p className="lbl">Type</p>
            <p>{device.comms_type}</p>
        </div>
        <div>
            <p className="lbl">Status</p>
            <p title="Possible states: Active, Sleeping, Offline" style={{color: color}}><b><Fa name='circle'/>&nbsp;{device.state}</b></p>

        </div>
        {device.comms_type !== 'POE' ?
        <div>
        <p className="lbl">Heartbeat</p>
        <p>
        {device.heartbeat_current_value}s
        </p>
        </div> : null}
        <div>
            <p className="lbl">Last connected</p>
            <p>
            { device.last_connection_established_time && device.last_connection_established_time !== 'N/A' ? moment(device.last_connection_established_time.slice(0,19)).format(fmt) : 'N/A'}
            </p>
        </div>
        <div>
            <p className="lbl">Last disconnected</p>
            <p>
            { device.last_disconnection_time && device.last_disconnection_time !== 'N/A' ? moment(device.last_disconnection_time.slice(0,19)).format(fmt) : 'N/A'}
            </p>
        </div>
        <div>
            <p className="lbl">Expected activation</p>
            <p>{device.expected_activation_time && device.expected_activation_time !== 'N/A' ? moment(device.expected_activation_time.slice(0,19)).format(fmt) : 'N/A'}
            </p>
        </div>
        <div className={device.battery_voltage !== 'N/A' && device.battery_voltage > 1 ? 'visible' : 'hidden'}>
            <p className="lbl"><Fa name="battery-3" />&nbsp;Battery</p>
            <p style={{color: bcolor}}>{device.battery_voltage} V</p>
        </div>
        <div className={device.rssi !== 'N/A'? 'visible' : 'hidden'}>
            <p className="lbl"><Fa name="wifi" />&nbsp;Network</p>
            <p title={"RSSI -" + device.rssi +"dBm"}>{network}</p>
        </div>
        <div className={device.temperature !== 'N/A' ? 'visible' : 'hidden'}>
            <p className="lbl"><Fa name="thermometer-half" />&nbsp;Temp</p>
            <p>{Math.round(device.temperature)}&deg;C</p>
        </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceInfoBar.js